import React, { useEffect, useRef, useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { Check, X, PencilSimple } from "@phosphor-icons/react";

export default function InlineNotesEditor({ value, onSave }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value || "");
  const [saving, setSaving] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {

    // eslint-disable-next-line
    setDraft(value || "");
  }, [value]);

  useEffect(() => {
    if (editing && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [editing]);

  const start = () => {
    setDraft(value || "");
    setEditing(true);
  };
  const cancel = () => {
    setDraft(value || "");
    setEditing(false);
  };
  const save = async () => {
    setSaving(true);
    try {
      await onSave(draft);
      setEditing(false);
    } finally {
      setSaving(false);
    }
  };

  if (editing) {
    return (
      <div className="space-y-2" data-testid="inline-notes-editing">
        <Textarea
          ref={textareaRef}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          rows={5}
          placeholder="Add notes about this customer…"
          className="bg-white"
          data-testid="inline-notes-textarea"
        />
        <div className="flex justify-end gap-2">
          <button
            onClick={cancel}
            className="inline-flex items-center gap-1 px-3 h-8 rounded-md border border-slate-200 bg-white text-slate-700 text-xs font-medium hover:bg-slate-50"
            data-testid="inline-notes-cancel"
          >
            <X size={14} /> Cancel
          </button>
          <button
            onClick={save}
            disabled={saving}
            className="inline-flex items-center gap-1 px-3 h-8 rounded-md bg-blue-600 text-white text-xs font-medium hover:bg-blue-700 disabled:opacity-60"
            data-testid="inline-notes-save"
          >
            <Check size={14} /> {saving ? "Saving…" : "Save"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      onClick={start}
      className="group cursor-text rounded-md p-2 -m-2 hover:bg-slate-50 transition-colors"
      data-testid="inline-notes-display"
    >
      {value?.trim() ? (
        <p className="text-sm text-slate-700 leading-relaxed whitespace-pre-wrap">
          {value}
        </p>
      ) : (
        <p className="text-sm text-slate-400 italic">
          Click to add notes about this customer…
        </p>
      )}
      <div className="mt-1 flex items-center gap-1 text-xs text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity">
        <PencilSimple size={12} /> Click to edit
      </div>
    </div>
  );
}
